import React from "react"
import css from "./NotFound.module.css"
export default ()=> {
    return (
        <div>
            <h1 className={css.NotFound}>Страница не найдена</h1>
        </div>
    )
}
